"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIAL_OWNER = void 0;
var INITIAL_OWNER = exports.INITIAL_OWNER = {
  'firstName': null,
  'surname': null,
  'dateofBirth': null,
  'day': null,
  'month': null,
  'year': null,
  'titleCode': null,
  'titleName': null,
  'genderName': null,
  'genderId': 0,
  'address': null,
  'suburb': null,
  'state': null,
  'postcode': null,
  'telephoneHome': null,
  'telephoneWork': null,
  'telephoneMobile': null,
  'email': null,
  'dpid': null,
  'barcode': null,
  'authorisedMemberFirstName': null,
  'authorisedMemberSurname': null,
  'authorisedMemberDob': null,
  'authorizedDay': null,
  'authorizedMonth': null,
  'authorizedYear': null,
  'hasAuthorisePerson': null,
  'hasInsuranceCancelled': false,
  'isEmailCommunicaton': null,
  'clientNumbers': null,
  'marketingConsent': null,
  'fullAddress': null
};